module.exports = __webpack_public_path__ + "img/map_small.ec420b79.svg";